import { AlertDialogAction } from "../../actions/components/AlertDialogAction";

export interface AlertDialogState {
  title: string;
  message: string;
  btnOnetext: string;
  btnOneOnclick: any;
  btnOneColor: string;
  btnTwotext: string;
  btnTwoOnclick: any;
  btnTwoColor: string;
  open: boolean;
}

const initialState = {
  title: "",
  message: "",
  btnOnetext: "",
  btnOneOnclick: "",
  btnOneColor: "",
  btnTwotext: "",
  btnTwoOnclick: "",
  btnTwoColor: "",
  open: false,
};

export function AlertDialogReducer(
  state: AlertDialogState = initialState,
  action: AlertDialogAction
): AlertDialogState {
  switch (action.type) {
    case "DISPLAY_ALERT_DIALOG":
      return {
        ...state,
        title: action.payload.title,
        message: action.payload.message,
        btnOnetext: action.payload.btnOnetext,
        btnOneOnclick: action.payload.btnOneOnclick,
        btnOneColor: action.payload.btnOneColor,
        btnTwotext: action.payload.btnTwotext,
        btnTwoOnclick: action.payload.btnTwoOnclick,
        btnTwoColor: action.payload.btnTwoColor,
        open: true,
      };
    case "CLOSE_ALERT_DIALOG":
      return {
        ...state,
        open: false,
      };
    default:
      return state;
  }
}
